import React from 'react';
import PropTypes from 'prop-types';
import FeaturedImage from '../FeaturedImage';
import useSettingsContext from '../../context/useSettingsContext';

function Program(props) {
  const {
    postType
  } = useSettingsContext();

  const {post} = props;
  let featuredImage;
  let registerLink;
  let categories;
  let categoriesLabel;
  let seasonsLabel;

  Program.propTypes = {
    post: PropTypes.object
  }

  if (post.featured_image !== undefined && post.featured_image) {
    featuredImage = <figure className="program-card__image-wrapper image-wrapper">
      <a href={post.link}>
        <FeaturedImage
          imageSize={'card-image-link-4'}
          image={post.featured_image}
          srcset={post.featured_image}
          className="program-card-horizontal__image"
        ></FeaturedImage>
      </a>
    </figure>
  } else if (post.eight29_custom.placeholder_image !== undefined && post.eight29_custom.placeholder_image) {
    featuredImage = <figure className="program-card__image-wrapper image-wrapper">
      <a href={post.link}>
        <img className="program-card-horizontal__image" src={post.eight29_custom.placeholder_image} alt="Hale Program Image"></img>
      </a>
    </figure>
  }

if (post.featured_image !== undefined && post.featured_image) {
	console.log(post.featured_image);
} else {
	console.log(post.eight29_custom.placeholder_image);	
}

  if (post.eight29_custom.primary_category !== undefined && post.eight29_custom.primary_category) {
    var catarray = post.eight29_custom.primary_category.split(";");
    categories = catarray.map((item) => <a href={item.substring(0, item.indexOf("="))} className="categories-component-category">{item.substring(item.indexOf("=")+1)}</a>);
  }

  if (post.eight29_custom.categories_label !== undefined && post.eight29_custom.categories_label) {
    categoriesLabel = <span className="categories-component-category" style={{pointerEvents:'none'}}>{post.eight29_custom.categories_label}</span>
  }

  if (post.eight29_custom.seasons_label !== undefined && post.eight29_custom.seasons_label) {
    seasonsLabel = <span className="categories-component-category" style={{pointerEvents:'none'}}>{post.eight29_custom.seasons_label}</span>
  }

  if (post.eight29_custom.register_link !== undefined && post.eight29_custom.register_link) {
    registerLink = <a href={post.eight29_custom.register_link} className="c-btn--small c-btn--primary c-btn--icon"><span>Enroll</span></a>
  }

  return (
    <article id={`${postType}-${post.id}`} className="program-card js-component-card">
      {featuredImage}

      <div className="categories-component">
	    {categoriesLabel}
	    {categories}
	    {seasonsLabel}
	  </div>

      <h3 className="program-card__title">
        <a className="program-card__title-link" href={post.link} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a>
      </h3>

      {post.eight29_custom.primary_age && <div className="program-card__meta"><div className="program-card__age">Ages: {post.eight29_custom.primary_age}</div></div>}

      <div className="program-card__excerpt">
        <div dangerouslySetInnerHTML={{__html: post.eight29_custom.excerpt_crop}}></div>
      </div>

      <div className="program-card__buttons">
        {registerLink}
        <a href={post.link} className="c-btn--small c-btn--tertiary c-btn--icon"><span>View Details</span><i className="icon-arrow-right icon"></i></a>
      </div>

    </article>
  );
}

export default Program;